import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import type { Id } from '@common/types';
import { BaseHttpService } from '@common/services/REST/base.http.service';

import type { StoredChatMessage } from './ai-chat-history.util';

/** The saved AI conversation of one page, per user (#73738). Neither response is enveloped in `data`. */
@Injectable({
    providedIn: 'root',
})
export class AiChatHistoryHttpService extends BaseHttpService {
    public getMessages(siteId: Id, pageId: Id): Observable<StoredChatMessage[]> {
        return this.http
            .get<{ messages?: StoredChatMessage[] }>(this.url(siteId, pageId))
            .pipe(map((response) => response?.messages ?? []));
    }

    /** Appends to the end; the server trims the whole conversation to its budget and says when it did. */
    public appendMessages(
        siteId: Id,
        pageId: Id,
        messages: StoredChatMessage[]
    ): Observable<{ count: number; truncated: boolean }> {
        return this.http.post<{ count: number; truncated: boolean }>(this.url(siteId, pageId), { messages });
    }

    private url(siteId: Id, pageId: Id): string {
        return this.formatApiUrl(`sites/${siteId}/pages/${pageId}/ai-chat-messages`);
    }
}
